import { Grid, Divider as MuiDivider, GridSpacing, Typography } from '@material-ui/core'

/**
 * `DividerText` component declaration.
 * @param {String} text
 * @param {Number} spacing
 * @return DividerText
 */
const DividerText = ({
  text,
  spacing,
}: {
  text: string
  spacing: GridSpacing
}) => (
  <Grid container alignItems="center" spacing={spacing}>
    <Grid item xs>
      <MuiDivider />
    </Grid>
    <Grid item>
      <Typography variant="body2" color="textSecondary" align="center">
        {text}
      </Typography>
    </Grid>
    <Grid item xs>
      <MuiDivider />
    </Grid>
  </Grid>
)

export default DividerText